///
/// EarthBrowser
///
/// Migration v44 to v45: Add placemarks slice
/// Created by Matt Giger on 9/17/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v44 to v45
 *
 * Changes:
 * - Seeds the new persisted placemarks slice (user's named places, each
 *   backed by 1..N locations) with an empty state for existing installs.
 * - Enables the "placemark" pseudo-layer (My Places pins) by default in
 *   earthbrowser.visibleDatasets.
 */
export function migrateV44toV45(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	let next = s
	if (!s.placemarks) {
		next = {
			...next,
			placemarks: {
				placemarks: {},
				deleted: {},
				lastSyncedAt: null,
			},
		}
	}

	const earthbrowser = next.earthbrowser as { visibleDatasets?: unknown } | undefined
	const visibleDatasets = earthbrowser?.visibleDatasets
	if (earthbrowser && Array.isArray(visibleDatasets) &&
		!visibleDatasets.includes("placemark")) {
		next = {
			...next,
			earthbrowser: {
				...earthbrowser,
				visibleDatasets: [...(visibleDatasets as unknown[]), "placemark"],
			},
		}
	}

	return next
}
